import React, { useState } from 'react';
import './Contact.css';

const WSP_NUMBER = '5491140882236';

function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const texto =
      `Hola, soy ${form.name}.\n` +
      (form.email ? `Email: ${form.email}\n` : '') +
      (form.phone ? `Teléfono: ${form.phone}\n` : '') +
      `\n${form.message}`;
    const url = `https://wa.me/${WSP_NUMBER}?text=${encodeURIComponent(texto)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="contact-section" id="contact-section">
      <div className="container">
        <h2>Contáctanos</h2>
        <div className="contact-content">
          <div className="contact-form">
            <h3>Envíanos un Mensaje</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Nombre</label>
                <input type="text" id="name" name="name" value={form.name} onChange={handleChange} required maxLength={80} />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="email" value={form.email} onChange={handleChange} maxLength={120} />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Teléfono</label>
                <input type="tel" id="phone" name="phone" value={form.phone} onChange={handleChange} maxLength={30} />
              </div>
              <div className="form-group">
                <label htmlFor="message">Mensaje</label>
                <textarea id="message" name="message" rows="5" value={form.message} onChange={handleChange} required maxLength={1000}></textarea>
              </div>
              <button type="submit" className="btn primary">Enviar por WhatsApp</button>
            </form>
          </div>

          <div className="contact-info-map">
            <div className="contact-details">
              <h3>Nuestros Datos de Contacto</h3>
              <p><strong>Dirección:</strong> Calle 824 2531, San Francisco Solano, Quilmes, Buenos Aires</p>
              <p><strong>Teléfono:</strong> +54 11 6208 1047</p>
              <p><strong>Email:</strong> <a href="mailto:info@batistta.com.ar">info@batistta.com.ar</a></p>
              <p>
                <strong>Instagram:</strong>{' '}
                <a href="https://instagram.com/bhargentina" target="_blank" rel="noopener noreferrer">
                  @bhargentina
                </a>
              </p>
              <p>
                <strong>Facebook:</strong>{' '}
                <a href="https://facebook.com/bhlamarcadelpanadero" target="_blank" rel="noopener noreferrer">
                  bhlamarcadelpanadero
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
